// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internal-warning[data-v-0745791f]{margin:var(--default-grid-baseline) !important}`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/InternalSignalingHint.vue"],"names":[],"mappings":"AACA,mCACC,8CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
